import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0044',
    ecrans: ['00-2'],
    params: ['id', '?pdfcleintnew', '?prucleint']
});
